module.exports = __webpack_public_path__ + "img/certificate-6.44c307e7.png";